import i18n from 'i18next';
import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getTotalPrice } from '../../../utils';
import { getActualProduct } from '../../../ServiceSummary/utils';
import { baggageOptionItemFactory } from './baggageOptionItemFactory';
import { mealOptionItemFactory } from './mealOptionItemFactory';
export function additionalOptionItemFactory({ key, travellerId, segmentsGroupsCount, selectedService, selectedSegmentsCount, gdsServiceRfisc, gdsServiceType, segments, products = [], isLoading }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const isAllSegments = key === 'allSegments';
    const serviceId = selectedService.servicePayload.id;
    const gdsService = selectedService.gdsService;
    const count = selectedService.number;
    const confirmedCount = (_a = selectedService.servicePayload) === null || _a === void 0 ? void 0 : _a.confirmedCount;
    const included = confirmedCount !== undefined && count === confirmedCount;
    const segment = !isAllSegments && segments.find(segment => segment.id === key);
    const direction = segment
        ? `${segment.departure.airport.iata} – ${segment.arrival.airport.iata}`
        : i18n.t('All flights', { ns: 'Cart' });
    const commonOptionProps = {
        id: serviceId,
        rfisc: gdsServiceRfisc
    };
    switch (gdsServiceType) {
        case 'Seat': {
            const seat = selectedService.servicePayload;
            const included = !seat.isChangeable && seat.isConfirmed && !seat.onRequest;
            return {
                id: seat.number,
                name: `${direction}, ${seat.number}`,
                price: ((_b = seat.seatServices) === null || _b === void 0 ? void 0 : _b.length)
                    ? getTotalPrice(seat.seatServices, service => service.price)
                    : seat.price,
                status: (_c = seat.product) === null || _c === void 0 ? void 0 : _c.status,
                deleteMeta: !included
                    ? {
                        serviceId: seat.number,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Seat,
                        allSegments: isAllSegments
                    }
                    : null,
                included,
                isLoading
            };
        }
        case 'Baggage':
        case 'Animal':
            const commonServiceObj = {
                key,
                travellerId,
                gdsServiceRfisc,
                count,
                confirmedCount,
                segmentsGroupsCount,
                products,
                isLoading,
                gdsService: gdsService
            };
            if (confirmedCount && count !== confirmedCount) {
                return [
                    baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'confirmed' })),
                    baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'booked' }))
                ];
            }
            return baggageOptionItemFactory(Object.assign(Object.assign({}, commonServiceObj), { groupType: 'all' }));
        case 'Meal': {
            const commonServiceFactoryObj = {
                key,
                serviceId,
                travellerId,
                gdsServiceRfisc,
                direction,
                count,
                confirmedCount,
                products,
                isLoading,
                gdsService: gdsService
            };
            if (confirmedCount && count !== confirmedCount) {
                return [
                    mealOptionItemFactory(Object.assign(Object.assign({}, commonServiceFactoryObj), { groupType: 'confirmed' })),
                    mealOptionItemFactory(Object.assign(Object.assign({}, commonServiceFactoryObj), { groupType: 'booked' }))
                ];
            }
            return mealOptionItemFactory(commonServiceFactoryObj);
        }
        case 'BusinessLounge':
        case 'CapsuleHotel':
        case 'PriorityBoarding': {
            const name = (_d = gdsService === null || gdsService === void 0 ? void 0 : gdsService.name) !== null && _d !== void 0 ? _d : i18n.t({
                BusinessLounge: 'Business lounge',
                CapsuleHotel: 'Capsule hotel',
                PriorityBoarding: 'Priority boarding'
            }[gdsServiceType], { ns: 'Checkout' });
            return Object.assign(Object.assign({}, commonOptionProps), { name, price: gdsService.price, status: (_e = getActualProduct(products)) === null || _e === void 0 ? void 0 : _e.status, deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.BusinessLounge,
                        allSegments: isAllSegments
                    }
                    : null, included,
                isLoading });
        }
        case 'Transfer': {
            const price = Object.assign({}, gdsService.price);
            price.amount *= segmentsGroupsCount;
            return Object.assign(Object.assign({}, commonOptionProps), { name: gdsService.name, segment: key, status: (_f = getActualProduct(products)) === null || _f === void 0 ? void 0 : _f.status, deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Vip,
                        allSegments: isAllSegments
                    }
                    : null, price,
                included,
                isLoading });
        }
        case 'Upgrade': {
            return Object.assign(Object.assign({}, commonOptionProps), { name: direction, price: selectedService.servicePayload.price, status: (_g = getActualProduct(products)) === null || _g === void 0 ? void 0 : _g.status, deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Vip,
                        allSegments: isAllSegments
                    }
                    : null, included,
                isLoading });
        }
        case 'RefundableTicket': {
            return Object.assign(Object.assign({}, commonOptionProps), { name: gdsService.name, included, price: selectedService.servicePayload.price, status: (_h = getActualProduct(products)) === null || _h === void 0 ? void 0 : _h.status, deleteMeta: null });
        }
        case 'Sms': {
            const price = Object.assign({}, gdsService.price);
            price.amount *= segmentsGroupsCount;
            return Object.assign(Object.assign({}, commonOptionProps), { name: gdsService.name, deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        allSegments: isAllSegments
                    }
                    : null, price,
                included,
                isLoading });
        }
        case 'Misc': {
            const price = Object.assign({}, gdsService.price);
            price.amount *= selectedSegmentsCount;
            return Object.assign(Object.assign({}, commonOptionProps), { name: gdsService.name, status: (_j = getActualProduct(products)) === null || _j === void 0 ? void 0 : _j.status, deleteMeta: !included
                    ? {
                        serviceId,
                        passengerId: travellerId,
                        segmentId: key,
                        type: OrderAdditionalServiceGdsServiceServiceType.Misc,
                        allSegments: isAllSegments
                    }
                    : null, included,
                price,
                isLoading });
        }
        default:
            return null;
    }
}
